module.exports = __webpack_public_path__ + "static/media/banner-tenant.9cb0f3fc.jpg";